const commonColumns = [
  {
    name: "category",
    title: "Categoria",
    editable: false,
    width: 170,
  },
  {
    name: "className",
    title: "Classe",
    editable: false,
    width: 133,
  },
  {
    name: "subcategory",
    title: "Subclasse",
    editable: false,
  },
];

const conservativeColumns = [
  {
    name: "minConsAllocation",
    title: "Conservador - Mínimo",
    type: "percentage",
    editable: true,
    width: 230,
  },
  {
    name: "recConsAllocation",
    title: "Conservador - Recomendado",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxConsAllocation",
    title: "Conservador - Máximo",
    type: "percentage",
    editable: true,
    width: 230,
  },
];

const moderateConservativeColumns = [
  {
    name: "minConsModAllocation",
    title: "Mod-Conservador - Mínimo",
    type: "percentage",
    editable: true,
    width: 230,
  },
  {
    name: "recConsModAllocation",
    title: "Mod-Conservador - Recomendado",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxConsModAllocation",
    title: "Mod-Conservador - Máximo",
    editable: true,
    type: "percentage",
    width: 230,
  },
];

const moderateColumns = [
  {
    name: "minModAllocation",
    title: "Moderado - Mínimo",
    type: "percentage",
    editable: true,
    width: 230,
  },
  {
    name: "recModAllocation",
    title: "Moderado - Recomendado",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxModAllocation",
    title: "Moderado - Máximo",
    type: "percentage",
    editable: true,
    width: 230,
  },
];

const moderateAggressiveColumns = [
  {
    name: "minModAggrAllocation",
    title: "Mod-Arrojado - Mínimo",
    type: "percentage",
    editable: true,
    width: 230,
  },
  {
    name: "recModAggrAllocation",
    title: "Mod-Arrojado - Recomendado",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxModAggrAllocation",
    title: "Mod-Arrojado - Máximo",
    type: "percentage",
    editable: true,
    width: 230,
  },
];

const aggressiveColumns = [
  {
    name: "minAggrAllocation",
    title: "Arrojado - Mínimo",
    type: "percentage",
    editable: true,
    width: 230,
  },
  {
    name: "recAggrAllocation",
    title: "Arrojado - Recomendado",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxAggrAllocation",
    title: "Arrojado - Máximo",
    type: "percentage",
    editable: true,
    width: 230,
  },
];

const currentPositionColumn = {
  name: "currentPosition",
  title: "Posição Atual",
  type: "percentage",
  editable: false,
  width: 150,
  isBalancingPosition: true,
};

const suggestedFundColumns = [
  {
    name: "suggestedFund1Name",
    title: "1ª Sugestão de Fundo",
    width: 350,
  },
  {
    name: "suggestedFund2Name",
    title: "2ª Sugestão de Fundo",
    width: 350,
  },
  {
    name: "suggestedFund3Name",
    title: "3ª Sugestão de Fundo",
    width: 350,
  },
];

const getcurrentPositionColumn = (walletProfile) => {
  return {
    ...currentPositionColumn,
    walletProfile,
  };
};

const getWalletBalancingTableColumns = (walletProfile) => {
  const columns = [
    ...commonColumns,
    ...(walletProfile === "conservative" ? conservativeColumns : []),
    ...(walletProfile === "mod_conservative"
      ? moderateConservativeColumns
      : []),
    ...(walletProfile === "moderate" ? moderateColumns : []),
    ...(walletProfile === "mod_aggressive" ? moderateAggressiveColumns : []),
    ...(walletProfile === "aggressive" ? aggressiveColumns : []),
    getcurrentPositionColumn(walletProfile),
    ...suggestedFundColumns,
  ];

  return columns;
};

const walletBalancingTableLeftFixedColumns = [
  "operations",
  "category",
  "className",
  "subcategory",
];

export { walletBalancingTableLeftFixedColumns, getWalletBalancingTableColumns };
// export default getWalletBalancingTableColumns;
